<template>
  <TopGradientBlockLayout>
    <div class="text-xl font-bold text-text leading-tight mb-11">Частые вопросы</div>
    <TicketsFAQGroup v-for="(faqItem,i) in faqData" :key="`faq-${i}`"
                     :group-name="faqItem.category_name">
      <TicketsFAQGroupItem v-for="(faq,j) in faqItem.questions" :key="`faq-${i}-${j}`"
                           :question="faq.question"
                           :answer="faq.answer">
      </TicketsFAQGroupItem>
    </TicketsFAQGroup>
  </TopGradientBlockLayout>
</template>

<script>
import TopGradientBlockLayout from "@/components/layouts/cabinet/TopGradientBlockLayout";
import TicketsFAQGroup from "@/components/cabinet/Tickets/TicketsFAQ/TicketsFAQGroup";
import TicketsFAQGroupItem from "@/components/cabinet/Tickets/TicketsFAQ/TicketsFAQGroupItem";
import {api} from "@/store/resources";

export default {
  name: "TheTicketsFAQ",
  components: {TicketsFAQGroupItem, TicketsFAQGroup, TopGradientBlockLayout},
  data() {
    return {
      faqData: null
    }
  },
  async created() {
    try {
      let {locale} = this.$i18n;
      const res = await api.faqs.get({locale});
      this.faqData = res.body.data;
    } catch (err) {
      this.$toasted.error('Ошибка')
      console.log(err)
    }
  }
}
</script>